import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChest = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 198 148",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7 52.4321H100.136V141.025H9C7.89543 141.025 7 140.129 7 139.025V52.4321Z",
			stroke: "#DAF6F0",
			strokeWidth: 13
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M102.407 52.4321H191V139.025C191 140.129 190.105 141.025 189 141.025H102.407V52.4321Z",
			stroke: "#DAF6F0",
			strokeWidth: 13
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.136 53.5679C100.136 41.2173 95.2296 29.3726 86.4964 20.6394C77.7632 11.9062 65.9185 7 53.5679 7C41.2173 7 29.3726 11.9062 20.6394 20.6394C11.9063 29.3726 7 41.2173 7 53.5679L53.5679 53.5679H100.136Z",
			stroke: "#DAF6F0",
			strokeWidth: 13
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.543 53.5679H144.432H191C191 41.2173 186.094 29.3726 177.36 20.6394C168.627 11.9062 156.783 7 144.432 7H54.7036",
			stroke: "#DAF6F0",
			strokeWidth: 13
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 147.84,
			cy: 84.2346,
			r: 4.54321,
			fill: "#DAF6F0",
			stroke: "#DAF6F0",
			strokeWidth: 13
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 147.525,
			y1: 91.0494,
			x2: 147.525,
			y2: 106.951,
			stroke: "#DAF6F0",
			strokeWidth: 13
		})
	]
});
const ForwardRef = forwardRef(SvgChest);
export default ForwardRef;
